import { Beforeunload } from './Beforeunload';
export default Beforeunload;
